import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3063917e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "更换设备", -1))
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { class: "form-block van-hairline--bottom" }
const _hoisted_5 = { class: "title-wrap" }
const _hoisted_6 = { class: "form-notice" }
const _hoisted_7 = { class: "upload-wrap" }
const _hoisted_8 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_9 = { class: "title-wrap" }
const _hoisted_10 = { class: "desc-count" }
const _hoisted_11 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "附件(故障视频、飞行日志文件等)")
], -1))
const _hoisted_13 = { class: "upload-file-wrap" }
const _hoisted_14 = {
  key: 0,
  class: "xag-ellipsis"
}
const _hoisted_15 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, 0.22)"}
}
const _hoisted_16 = {
  key: 0,
  class: "certificate-placeholder"
}
const _hoisted_17 = { class: "sn-info" }

import { Field } from 'vant'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { getEntryInfo } from '@/utils'
import { UploadImageVm } from '@/components/upload'
import { createOrder, getRepairDeviceDetail, resetEquipmentExtend } from '@/apis/malfunction-repair'
import dayjs from 'dayjs'
import type { CommonUploaderFileListItem } from '@/types/public'
import { computed, onActivated, onMounted, reactive, ref, Ref, watch } from 'vue'
import { showConfirmModal, showToastLoading, clearToast } from '@/utils/tools'
import {
  useMalfunctionRepairStore,
  useCreateOrderSuccessHandle,
  useMalfunctionRepairAddressInfo,
} from '@/compositions/malfunction-repair/index'
import { MalfunctionRepairSelectedDevicesStorage } from '@/storage/malfunction-repair'
import type {
  MalfunctionRepairCertificateListItem,
  CreateMulfunctionRepairOrderParams,
  CreateMulfunctionRepairOrderParamsItem,
  MalfunctionRepairDeviceListRenderItem,
} from '@/types/malfunction-repair'
import { USER_AFTERSALE_REPAIR_CAMERA_AUTH } from '@/config/constant'
import AppHeader from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import CommonWrap from '@/components/popup/common-wrap.vue'
import CameraExample from './components/camera-example.vue'
import CacheUsePopup from './components/cache-use-popup.vue'
import UploadImage from '@/components/upload/UploadImage.vue'
import LabelTitleWrap from './components/label-title-wrap.vue'
import NetworkInfoBlock from './components/network-info-block.vue'
import FaultFormDeviceInfo from './components/fault-form-device.vue'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import FaultFormChangeDevice from './components/fault-form-change-device.vue'
import UploadFile from '@/components/upload/newUploadFIle.vue'
import ShrinkWrap from '@/components/shrink-wrap.vue'
import RepairTypeBlock from './components/repair-type-block.vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'malfunction-repair-fault-form',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $store = useStore()
const $router = useRouter()
const $route = useRoute()
let uploadInstance: null | UploadImageVm = null

function getRouteSnList(): string[] {
  const snQuery = ($route.query.sn as string) || ''
  return snQuery
    .split(',')
    .map((item) => item.trim())
    .filter((item) => !!item)
}

/** 直接带 sn 跳入（如 triage / 外链），非 devices 列表选设备进入 */
function isDirectRouteEntry(): boolean {
  return getRouteSnList().length > 0
}

const cacheDeviceInfo =
  MalfunctionRepairSelectedDevicesStorage.get<MalfunctionRepairDeviceListRenderItem[]>() || []
const deviceInfoList: Ref<MalfunctionRepairDeviceListRenderItem[]> = ref(
  isDirectRouteEntry() ? [] : cacheDeviceInfo || []
)
const defaultSelected = computed(() => deviceInfoList.value.map((item) => item.guid))
const {
  malfunctionRepairState,
  setFormFirstData,
  addFaultFormKeepAlive,
  getUserLocation,
  initFlylogs,
  changeSelectedLogGuid,
  changeBoomValue,
  setSelectedLogItem,
} = useMalfunctionRepairStore()
const { createSuccessHandle } = useCreateOrderSuccessHandle()
const { receive_express, getCacheAddressStr } = useMalfunctionRepairAddressInfo()
const cacheFormData = malfunctionRepairState.firstData
const faultImageList: Ref<CommonUploaderFileListItem[]> = ref(
  isDirectRouteEntry() ? [] : cacheFormData?.files || []
)
const annextList: Ref<CommonUploaderFileListItem[]> = ref(
  isDirectRouteEntry() ? [] : cacheFormData?.annextList || []
)
const addressStr = ref('')
const form = reactive({
  description: isDirectRouteEntry() ? '' : cacheFormData?.description || '',
  images: [],
  receive_express: {
    ...receive_express,
  },
  is_pay: isDirectRouteEntry() ? 0 : cacheFormData?.is_pay ?? 0,
})

let ShrinkWrapRef = ref<InstanceType<typeof ShrinkWrap>>(null)
const sn = computed(() => {
  return deviceInfoList.value.map((item) => item.serial_number)[0] || ''
})
const { platform } = getEntryInfo()

const certificateList: Ref<
  Array<{
    description: string
    name: string
    sn: string
    files: Array<CommonUploaderFileListItem>
    checked: boolean
  }>
> = ref([])

const eqType = computed(() => {
  const type = deviceInfoList.value[0]?.type
  if (type === 1) {
    return 1
  }
  return 2
})
const isPay = computed(() => {
  return form.is_pay === 1
})

watch(
  () => {
    if (isPay.value) {
      ShrinkWrapRef.value?.setShrink(true)
    } else {
      ShrinkWrapRef.value?.setShrink(false)
    }
  },
  () => isPay.value
)
const cachePopupCanShow = computed(() => {
  return (
    !malfunctionRepairState.hasUseCache &&
    !form.description &&
    !isUploadDone.value &&
    !hasUploading.value
  )
})
const changeDeviceShow = ref(false)
const cacheUsePopupShow = ref(false)
const nextButtonLoading = ref(false)
const initDeviceLoading = ref(false)
const descCount = computed(() => {
  return form.description.length
})
const isUav = computed(() => {
  // 是否为植保整机提单
  return eqType.value === 1
})
const messageTips = computed(() => {
  return isUav.value
    ? '* 至少上传3张图片，包含事故现场照片、受损部位照片、机器铭牌照片。'
    : '需上传设备或故障照片'
})
const confirmText = computed(() => {
  return isUav.value ? '下一步' : '确认提单'
})
const isUploadDone = computed(() => {
  //  六大类上传完毕的图片数量大于1
  //  植保机上传完毕的图片数量要大于等于3
  const list = faultImageList.value
  return (
    list.filter((item) => item.status === 'done' && item?.response?.guid).length >
    (isUav.value ? 2 : 0)
  )
})
const hasUploading = computed(() => {
  // 是否有正在上传的图片
  const list = faultImageList.value
  return list.filter((item) => item.status === 'uploading').length > 0
})
const canNext = computed(() => {
  // 植保机提单时需确认故障描述和图片必填
  // 若是非植保机提单需确认有选择网点
  return (
    (form.description &&
      isUploadDone.value &&
      !hasUploading.value &&
      (isUav.value ? true : malfunctionRepairState.networkInfo)) ||
    isPay.value
  )
})
function initCertificateList() {
  const certificateListSnList = certificateList.value.map((item) => item.sn)
  const deviceInfoListSnList = deviceInfoList.value.map((item) => item.serial_number)
  const newList = deviceInfoList.value
    .filter((item) => {
      const bool = certificateListSnList.indexOf(item.serial_number) === -1
      return bool
    })
    .map((item) => {
      const current = malfunctionRepairState?.certificateDataSnMap?.[item.serial_number]
      return {
        description: current?.description || '',
        name: item.name || '',
        sn: item.serial_number || '',
        files: current?.files || [],
        checked: current?.checked || false,
      }
    })
  certificateList.value = certificateList.value
    .filter((item) => {
      const bool = deviceInfoListSnList.indexOf(item.sn) !== -1
      if (!bool) {
        // 删除已经填写的内容
        delete malfunctionRepairState?.certificateDataSnMap?.[item.sn]
      }
      return bool
    })
    .concat(newList)
}
function updateCertificateList() {
  certificateList.value.forEach((item) => {
    const current = malfunctionRepairState?.certificateDataSnMap?.[item.sn]
    item.description = current?.description || ''
    item.files = current?.files || []
  })
}
function cellWrapLabelStyle(item: MalfunctionRepairCertificateListItem) {
  // 特别处理产品名称可能存在过长的问题
  if (!item.description && item?.files.length === 0) {
    return {
      width: 'calc(100vw - 186px)',
    }
  }
  return {}
}
function uplodaInit(vm: UploadImageVm) {
  uploadInstance = vm
}
async function nextHandle() {
  if (nextButtonLoading.value) {
    return
  }
  nextButtonLoading.value = true
  try {
    if (isUav.value && !isPay.value) {
      saveCacheData()
      const snQuery = ($route.query.sn as string) || ''
      if (snQuery) {
        await toNetworkBySn(snQuery)
        return
      }
      $router.push({
        name: 'malfunction-repair-fault-logs',
      })
    } else if (isUav.value && isPay.value) {
      saveCacheData()
      $router.push({
        name: 'malfunction-repair-network-list',
        query: {
          sn: sn.value,
          isPay: form.is_pay,
        },
      })
    } else {
      // 非植保机时直接提单
      await submitOrder()
    }
  } finally {
    nextButtonLoading.value = false
  }
}
async function toNetworkBySn(snQuery: string) {
  try {
    let flyLogs = malfunctionRepairState.flylogsSnMap[snQuery]
    if (flyLogs === undefined) {
      flyLogs = await initFlylogs(snQuery)
    }
    const boomLog = (flyLogs || []).find((item) => item.isBoom)
    const selectedLog = boomLog || (flyLogs || [])[0]
    if (selectedLog?.guid) {
      changeSelectedLogGuid(selectedLog.guid)
      changeBoomValue(!!selectedLog.isBoom)
      setSelectedLogItem(selectedLog)
      $router.push({
        name: 'malfunction-repair-log-analysis',
        query: {
          guid: selectedLog.guid,
          sn: snQuery,
          is_boom: selectedLog.isBoom ? 'true' : 'false',
        },
      })
      return
    }
  } catch (error) {
    console.error('toNetworkBySn error', error)
  }
  changeSelectedLogGuid('')
  $router.push({
    name: 'malfunction-repair-fault-logs',
  })
}
async function submitOrder() {
  let lnglat: {
    lat?: number | string
    lng?: number | string
    unAuth?: boolean
  } = {}
  let getLngLatErrorMessage = ''
  try {
    lnglat = await getUserLocation()
    if (lnglat.unAuth) {
      getLngLatErrorMessage = '请同意获取您的经纬度信息继续提单操作'
    }
  } catch (error) {
    getLngLatErrorMessage = (error as { message: string })?.message
  }
  if (getLngLatErrorMessage) {
    await showConfirmModal({
      title: '提示',
      confirmButtonText: '我知道了',
      showCancelButton: false,
      message: getLngLatErrorMessage || '获取经纬度失败',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
    return
  }
  const params: CreateMulfunctionRepairOrderParams = deviceInfoList.value.map((item) => {
    const currentCertificate = malfunctionRepairState?.certificateDataSnMap?.[item.serial_number]
    const result: CreateMulfunctionRepairOrderParamsItem = {
      process_type: 'EQ_OTHER',
      serial_number: item.serial_number,
      images: faultImageList.value.map((item) => item?.response?.guid).filter((val) => val),
      annex: annextList.value
        .filter((item) => item.status === 'done')
        .map((item) => {
          let nameArr = item?.response?.fileName.split('.')
          return {
            url: item?.response?.guid,
            suffix: nameArr[nameArr.length - 1],
            file_name: item?.response?.fileName,
          }
        }),
      description: form.description,
      lat: String(lnglat.lat),
      lng: String(lnglat.lng),
      repair_warehouse_guid: malfunctionRepairState.networkInfo.guid,
      repair_warehouse_type: malfunctionRepairState.networkInfo.type,
      receive_express,
      is_pay: form.is_pay,
    }
    if (
      currentCertificate &&
      (currentCertificate?.description || currentCertificate?.files?.length)
    ) {
      result.certificate = {
        description: currentCertificate.description,
        images: currentCertificate.files.map((item) => item?.response?.guid).filter((val) => val),
      }
    }
    return result
  })
  // console.log('prames', prames)
  try {
    await showConfirmModal({
      className: 'fault-module',
      title: '确定提交？',
      message: '网点接单后，为了检测和维修设备，设备使用权会发生变更。',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    const createOrderData = await createOrder(params)
    let guid = createOrderData.guids[0]
    createSuccessHandle(guid, {
      hasMoreDevices: deviceInfoList.value.length > 1,
      is_pay: isPay.value,
    })
  } catch (error) {
    // commonErrorHandle(error)
    clearToast()
    const errorObj = error as { message: string }
    showConfirmModal({
      title: '提单失败',
      message: errorObj?.message || '',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
  }
}
function saveCacheData() {
  console.log('saveCacheData', annextList.value)
  setFormFirstData({
    description: form.description,
    files: faultImageList.value,
    annextList: annextList.value,
    is_pay: form.is_pay,
  })
}
function confirmUseCache(data: { description: string; files: File[]; deviceId: string }) {
  form.description = data.description
  console.log('data.files', data.files)
  // 判断到有图片文件后帮助上传
  uploadInstance?.addFiles(data.files)
  // 设置已使用缓存
  malfunctionRepairState.hasUseCache = true
  malfunctionRepairState.useCacheId = data.deviceId
}

function confirmChange(devices: MalfunctionRepairDeviceListRenderItem[]) {
  console.log('description', form.description)
  if (
    devices[0].serial_number !== sn.value &&
    !form.description &&
    !isUploadDone.value &&
    !hasUploading.value
  ) {
    // 更换其他的设备后询问是否使用缓存
    // 只在描述和图片未填时询问
    // 图片有正在上传的也不使用缓存
    malfunctionRepairState.hasUseCache = false
    malfunctionRepairState.useCacheId = ''
  }
  deviceInfoList.value = devices
  changeDeviceShow.value = false
  if (!isUav.value) {
    initCertificateList()
  }
}
function imageListChange(data: CommonUploaderFileListItem[]) {
  faultImageList.value = data
    .filter((item) => item.url && item.status === 'done')
    .map((item) => ({ ...item, content: '' }))
}

function annexListChange(data: CommonUploaderFileListItem[]) {
  console.log(
    'annexListChange',
    data,
    data
      .filter((item) => {
        console.log('ddd', item.url, item.status)
        return item.url && item.status === 'done'
      })
      .map((item) => ({ ...item, content: '' }))
  )
  annextList.value = data
    .filter((item) => item.url && item.status === 'done')
    .map((item) => ({ ...item, content: '' }))
}
function toEditAddress() {
  saveCacheData()
  $router.push({
    name: 'malfunction-repair-fault-address',
  })
}
function changeCertificate(item: MalfunctionRepairCertificateListItem) {
  saveCacheData()
  $router.push({
    name: 'malfunction-repair-certificate-form',
    query: {
      sn: item.sn,
    },
  })
}
function updateAddress() {
  addressStr.value = getCacheAddressStr()
}

function repairTypeChange(index: number) {
  form.is_pay = index
}

/** 直接跳入：按路由 sn 拉最新设备，并应用路由 description */
async function initDirectRouteEntry() {
  applyDescriptionFromRoute()
  await initDeviceInfoListByRouteSn()
}

function applyDescriptionFromRoute() {
  const raw = $route.query.description
  if (raw == null || raw === '') {
    return
  }
  const value = (Array.isArray(raw) ? raw[0] : raw) || ''
  if (!value) {
    return
  }
  let description = value
  if (/%[0-9A-Fa-f]{2}/.test(value)) {
    try {
      description = decodeURIComponent(value.replace(/\+/g, ' '))
    } catch {
      description = value
    }
  }
  const text = description.slice(0, 200)
  if (!text) {
    return
  }
  form.description = text
  setFormFirstData({
    description: text,
    files: faultImageList.value,
    annextList: annextList.value,
    is_pay: form.is_pay,
  })
}

async function initDeviceInfoListByRouteSn() {
  if (initDeviceLoading.value) {
    return
  }
  initDeviceLoading.value = true
  showToastLoading({
    message: '设备信息加载中...',
  })
  try {
    const snList = getRouteSnList()
    if (snList.length === 0) {
      return
    }
    const result = await Promise.allSettled(
      snList.map((serial_number) => getRepairDeviceDetail(serial_number))
    )
    const list: MalfunctionRepairDeviceListRenderItem[] = []
    result.forEach((item) => {
      if (item.status === 'fulfilled' && item.value?.serial_number) {
        list.push(item.value as MalfunctionRepairDeviceListRenderItem)
      }
    })
    if (list.length) {
      deviceInfoList.value = list
      MalfunctionRepairSelectedDevicesStorage.set(list)
    }
  } finally {
    initDeviceLoading.value = false
    clearToast()
  }
}

/** 质保时间展示格式（quality 字符串以 '-' 拆分展示，日期内不能含 '-'） */
const QUALITY_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss'

/** 页面加载时按序列号重置设备质保时间并回填展示，异步执行、不阻塞页面其他流程 */
async function resetDeviceQualityTime() {
  const list = deviceInfoList.value
  if (!list.length) {
    return
  }
  let hasUpdate = false
  await Promise.allSettled(
    list.map(async (item) => {
      item.qualityResetLoading = true
      try {
        const data = await resetEquipmentExtend(item.serial_number)
        if (!data?.quality_start_at || !data?.quality_end_at) {
          return
        }
        const start = dayjs(data.quality_start_at).format(QUALITY_TIME_FORMAT)
        const end = dayjs(data.quality_end_at).format(QUALITY_TIME_FORMAT)
        item.quality = `${start} - ${end}`
        item.is_quality = dayjs(data.quality_end_at).valueOf() >= Date.now() ? 1 : 2
        hasUpdate = true
      } catch (error) {
        console.error('resetEquipmentExtend error', error)
      } finally {
        item.qualityResetLoading = false
      }
    })
  )
  if (hasUpdate) {
    // 同步最新质保数据到设备缓存，保证 fault-submit / fault-logs 等页展示一致
    MalfunctionRepairSelectedDevicesStorage.set(deviceInfoList.value)
  }
}

onMounted(async () => {
  if (isDirectRouteEntry()) {
    await initDirectRouteEntry()
  } else {
    applyDescriptionFromRoute()
  }
  addFaultFormKeepAlive()
  updateAddress()
  initCertificateList()
  // 异步重置质保时间，不 await，不阻塞页面其他流程
  resetDeviceQualityTime()
})
onActivated(() => {
  applyDescriptionFromRoute()
  updateAddress()
  updateCertificateList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "故障报修" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LabelTitleWrap, { title: "报修设备" }, {
        default: _withCtx(() => [
          _createVNode(IconArrowRightWrap, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeDeviceShow.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(FaultFormDeviceInfo, { deviceInfoList: deviceInfoList.value }, null, 8, ["deviceInfoList"]),
      _createVNode(RepairTypeBlock, {
        class: "repair-type-block",
        onChange: repairTypeChange
      }),
      (!_unref(isUav))
        ? (_openBlock(), _createBlock(NetworkInfoBlock, {
            key: 0,
            onJump: saveCacheData,
            sn: _unref(sn),
            changeMode: "other"
          }, null, 8, ["sn"]))
        : _createCommentVNode("", true),
      _createVNode(ShrinkWrap, {
        class: "falut-info-block",
        title: "故障信息",
        ref_key: "ShrinkWrapRef",
        ref: ShrinkWrapRef
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'red-star': !_unref(isPay) })
                }, "故障照片", 2),
                (_unref(isUav))
                  ? (_openBlock(), _createBlock(CameraExample, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(messageTips)), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(UploadImage, {
                  onChange: imageListChange,
                  onInit: uplodaInit,
                  defaultList: faultImageList.value,
                  capture: "camera",
                  cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH)
                }, null, 8, ["defaultList", "cameraAuthKey"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'red-star': !_unref(isPay) })
                }, "故障描述", 2),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(descCount)) + "/200", 1)
              ]),
              _createVNode(_unref(Field), {
                rows: "3",
                type: "textarea",
                maxlength: "200",
                class: "desc-textarea",
                modelValue: form.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.description) = $event)),
                placeholder: "请填写故障报修原因，方便维修人员排查故障情况！"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(UploadFile, {
                  maxCount: 3,
                  defaultList: annextList.value,
                  onChange: annexListChange,
                  cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH)
                }, null, 8, ["defaultList", "cameraAuthKey"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(CellWrap, {
        label: "回寄地址",
        style: {"margin-top":"12px"},
        fillColor: "rgba(0, 0, 0, 0.44)",
        onClick: toEditAddress
      }, {
        "cell-right": _withCtx(() => [
          (addressStr.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(addressStr.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, "请填写回寄地址"))
        ]),
        _: 1
      }),
      (!_unref(isUav))
        ? (_openBlock(), _createBlock(LabelTitleWrap, {
            key: 1,
            title: "购买凭证",
            style: {"margin-top":"12px"}
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificateList.value, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(CellWrap, {
          key: index,
          label: item.name,
          style: _normalizeStyle(index === 0 ? '' : 'margin-top: 12px'),
          fillColor: "rgba(0, 0, 0, 0.44)",
          mainLinePb: 8,
          onClick: ($event: any) => (changeCertificate(item)),
          labelStyle: cellWrapLabelStyle(item)
        }, {
          "cell-right": _withCtx(() => [
            (!item.description && item?.files.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 请填写购买凭证 "))
              : _createCommentVNode("", true)
          ]),
          block: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, "序列号：" + _toDisplayString(item.sn), 1)
          ]),
          _: 2
        }, 1032, ["label", "style", "onClick", "labelStyle"])), [
          [_vShow, !_unref(isUav)]
        ])
      }), 128))
    ]),
    _createVNode(CommonWrap, {
      show: changeDeviceShow.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((changeDeviceShow).value = $event)),
      title: "更换设备"
    }, {
      default: _withCtx(() => [
        _createVNode(FaultFormChangeDevice, {
          eq_type: _unref(eqType),
          defaultSelected: _unref(defaultSelected),
          onConfirm: confirmChange,
          selectedList: deviceInfoList.value
        }, null, 8, ["eq_type", "defaultSelected", "selectedList"])
      ]),
      _: 1
    }, 8, ["show"]),
    (_openBlock(), _createBlock(CacheUsePopup, {
      onHide: _cache[3] || (_cache[3] = ($event: any) => (cacheUsePopupShow.value = false)),
      onShow: _cache[4] || (_cache[4] = ($event: any) => (cacheUsePopupShow.value = true)),
      sn: _unref(sn),
      key: _unref(sn),
      canShow: _unref(cachePopupCanShow),
      onConfirm: confirmUseCache
    }, null, 8, ["sn", "canShow"])),
    _createVNode(CommonFooterNextButton, {
      onClick: nextHandle,
      disabled: !_unref(canNext) || nextButtonLoading.value,
      loading: nextButtonLoading.value,
      title: _unref(confirmText)
    }, null, 8, ["disabled", "loading", "title"])
  ], 64))
}
}

})